import { render, staticRenderFns } from "./creditcard-payer.vue?vue&type=template&id=3bdf3e08"
import script from "./creditcard-payer.vue?vue&type=script&lang=js"
export * from "./creditcard-payer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports